import { ROUTE } from "../../../routes";
import { api, StoreKey } from "../../../configs/api";
import sharedPropsService from "../../../SharedPropsService";
import { CreditApplicationType, getAppHeader } from "../../../configs/config";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { CreditApplicationStepId } from "../../../configs/constants";
export const goBack = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.DASHBOARD);
};
export const needHelp = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const navFaq = async (action, _datastore, { navigate }) => {
    const tenureInDays = action?.payload?.tenureInDays;
    await navigate(ROUTE.FAQ, { tenureInDays: tenureInDays });
};
export const navNext = async (action, _datastore, { navigateWithClear, network }) => {
    console.warn('**** navNext ACTION Triggered ****');
    const _user = await sharedPropsService.getUser();
    const creditId = _user.linkedCredits[0].creditId;
    const creditModificationResponse = await network.post(`${api.getLimitModificationApplicationForAccountV2}${creditId}/v2`, {
        creditApplicationType: CreditApplicationType.CREDIT_RENEWAL_AGAINST_SECURITIES
    }, {
        headers: await getAppHeader(),
    });
    if (creditModificationResponse?.status === 200) {
        const applicationId = creditModificationResponse?.data?.applicationId;
        await AsyncStorage.setItem(StoreKey.APPLICATION_ID, applicationId);
        const currentStepId = creditModificationResponse?.data?.currentStepId;
        if (currentStepId === CreditApplicationStepId.OFFER_SELECTION) {
            await navigateWithClear(ROUTE.LOAN_RENEWAL_VERIFY_SUMMARY_PAGE);
        }
        else {
            await navigateWithClear(ROUTE.KYC_STEPPER);
            // const routeObj = await nextStepCredStepper(currentStepId);
            // await navigateWithClear(routeObj.routeId, routeObj.params)
        }
    }
};
